/**
 * The one definition of "phone" for every chat surface.
 *
 * The mobile shell (fullscreen chat, round bubble, no floating panel) applies
 * below 768px width, or on a coarse-pointer device shorter than 500px so a
 * phone in landscape keeps it. The `.98` bounds close the fractional-pixel gap
 * that a 767/768 pair leaves under browser zoom.
 *
 * Mirrored by the `mobile-shell` / `desktop-shell` mixins in
 * `src/styles/_mobile-shell.scss` and the `desktop-shell:` Tailwind variant
 * (`tailwind.config.js`); a Jest test keeps the three in sync.
 */
export const MOBILE_SHELL_QUERY =
	'(max-width: 767.98px), (pointer: coarse) and (max-height: 499.98px)';

/** Used only where `matchMedia` does not exist (very old browsers, jsdom). */
const FALLBACK_MAX_WIDTH_PX = 768;

/**
 * Is the current window in the mobile shell?
 */
export function isMobileShell(): boolean {
	if ( typeof window === 'undefined' ) {
		return false;
	}
	if ( typeof window.matchMedia !== 'function' ) {
		return window.innerWidth < FALLBACK_MAX_WIDTH_PX;
	}
	return window.matchMedia( MOBILE_SHELL_QUERY ).matches;
}
